import { useContext } from 'react'

import RoadmapPage from '@/components/roadmap/RoadmapPage'
import UserChangelogList from '@/components/users/screens/UserChangelogList'
import UserPostListPage from '@/components/users/screens/UserPostListPage'
import HNContext from '@/context/HNContext'

const EmbedHomePage = () => {
  const { default_module: defaultModule } = useContext(HNContext)

  switch (defaultModule) {
    case 'changelog':
      return <UserChangelogList initialChangelogs={[]} />
    case 'roadmap':
      return <RoadmapPage />
    case 'feedback':
    default:
      return <UserPostListPage initialPosts={[]} />
  }
}

export default EmbedHomePage
